import { configureStore } from '@reduxjs/toolkit';
import calculatorSlice from './slices/calcutator.slice';
import contactSlice from './slices/contact.slice';
import postSlice from './slices/post.slice';
import { postApi } from './services/post.services';
// import { mailingApi } from './services/mailing.services';
import componentSlice from './slices/components.slice';

export const store = configureStore({
    reducer: {
        calculatorSlice,
        contactSlice,
        postSlice,
        componentSlice,
        [postApi.reducerPath]: postApi.reducer,
        // [mailingApi.reducerPath]: mailingApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat([
            postApi.middleware,
            // mailingApi.middleware,
        ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
